import {
  ApiGetListingGeneralKeys,
  ApiGetListingGeneralValue,
} from "../../Services";
import {
  LISTING_GENERAL_KEYS_FAIL,
  LISTING_GENERAL_KEYS_REQUEST,
  LISTING_GENERAL_KEYS_SUCCESS,
  LISTING_GENERAL_VALUE_FAIL,
  LISTING_GENERAL_VALUE_REQUEST,
  LISTING_GENERAL_VALUE_SUCCESS,
} from "../Actions";

export const ListingGeneralKeysThunk = () => {
  return async (dispatch) => {
    dispatch({
      type: LISTING_GENERAL_KEYS_REQUEST,
    });
    try {
      const response = await ApiGetListingGeneralKeys();
      const { data } = response;

      dispatch({
        type: LISTING_GENERAL_KEYS_SUCCESS,
        payload: data?.data,
      });
    } catch ({ response }) {
      const { data } = response;
      dispatch({
        type: LISTING_GENERAL_KEYS_FAIL,
        payload:
          typeof data?.error?.message === "string"
            ? data?.error?.message
            : data?.error?.message[0],
      });
    }
  };
};

export const ListingGeneralValueThunk = () => {
  return async (dispatch) => {
    dispatch({
      type: LISTING_GENERAL_VALUE_REQUEST,
    });
    try {
      const response = await ApiGetListingGeneralValue();
      const { data } = response;

      dispatch({
        type: LISTING_GENERAL_VALUE_SUCCESS,
        payload: data?.data,
      });
    } catch ({ response }) {
      const { data } = response;
      dispatch({
        type: LISTING_GENERAL_VALUE_FAIL,
        payload:
          typeof data?.error?.message === "string"
            ? data?.error?.message
            : data?.error?.message[0],
      });
    }
  };
};
